import { Pipe, PipeTransform, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { UserApiService } from 'shared/services';
import { map, takeUntil, takeWhile, tap, filter, switchMap } from 'rxjs/operators';
import { UserDelayApiService } from 'shared/services/user-delay-api.service';
import { empty, Subject } from 'rxjs';

@Pipe({
  name: 'userName',
  pure: false
})
export class UserNamePipe implements PipeTransform, OnDestroy {
  onDestroy$ = new Subject();
  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  constructor(
    private api: UserApiService,
    private delayApi: UserDelayApiService,
    private changeDetectorRef: ChangeDetectorRef) {

  }
  trackKey: string;
  data: string;
  transform(value: string | string[], ...args: unknown[]): string {
    if (!value) return ''
    if (Array.isArray(value) && value.length == 0) return '';
    let trackKey: string;
    if (typeof value === "string") {
      trackKey = value;
      if (trackKey !== this.trackKey) {
        this.trackKey = trackKey;
        this.delayApi.users$.pipe(
          takeUntil(this.onDestroy$),
          filter(users => users.map(u => u.id).indexOf(value) >= 0),
          tap(users => {
            const user = users.find(u => u.id == value);
            this.data = user.realName || user.userName;
            this.changeDetectorRef.markForCheck();
          }),
          switchMap(() => empty())
        ).subscribe();
        this.delayApi.add(value);
      }
    }
    else if (Array.isArray(value)) {
      trackKey = value.join(",");
      if (trackKey !== this.trackKey) {
        this.trackKey = trackKey;
        this.delayApi.users$.pipe(
          takeUntil(this.onDestroy$),
          filter(users => {

            return value.findIndex(v => users.findIndex(u => u.id == v) < 0) < 0;
          }),
          tap(users => {
            const data = users.filter(u => value.findIndex(v => v == u.id) >= 0).map(u => u.realName || u.userName).filter(p => p != undefined).join(",");
            this.data = data;
            this.changeDetectorRef.markForCheck();
          }),
          switchMap(() => empty())
        ).subscribe();
        this.delayApi.add(value);
      }
    }
    return this.data;
  }

}
